import {ChangeDetectorRef, HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {IRule} from '../../irule';
import {UserpermissionService} from '../../services/userpermission.service';
import{ArticleService} from '../../services/article.service';
import {UserService} from '../../services/user.service';

declare var $:any

@Component({
  selector: 'app-external-user-profile',
  templateUrl: './external-user-profile.component.html',
  styleUrls: ['./external-user-profile.component.css']
})
export class ExternalUserProfileComponent implements OnInit,IRule {

  @HostBinding('style.width') public width: string = '100%';

  userName='';
  navigationsType=[];
  notification:any=[];
  msg:any;
	toastr:any;
  _router:any;
  token:any='';

  loader_image:boolean =true
  name:any;
  email:any;
  phone:any;
  country:any;
  company:any;
  designation:any;
  pass:any='';
  confirm:any='';
  
  msgSubscribe:Subscription;
  userId:any;
  external:any=1;
  admin:boolean=false;
  
  constructor(private _activatedRoute: ActivatedRoute,msg:MessageService, toastr: ToastrService, _router: Router,private articleService:ArticleService,private userService:UserService,private userpermissionService:UserpermissionService) { 
  	this.msg = msg;
    this.toastr = toastr;
    this._router =_router;

    try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);


      this.token = tokenA.token;


      let data={
        token:tokenA.token,
        // 'page':'exprofile'
      }
     

    }catch(error){

      this._router.navigate(['/vlogin']);

    }

    this.msgSubscribe = this.msg.getMessage().subscribe( (evt) => {
     
      if(evt!=undefined){

         
       switch(evt.text.type){
         
         case 'exprofile':

         this.userId = evt.text.userId
         this.external = evt.text.external
         this.admin = evt.text.admin
         let res= evt.text.data
         this.userName=res.user.name;
         this.navigationsType=res.navigation;
         this.notification =res.notification;

         this.fetchExprofileData()
         this.broadcast_menu();
         
         break;


       }

      }

   });

   if(this._activatedRoute.snapshot.routeConfig.path=='user/exprofile'){
     this.admin=true
   }else if(this._activatedRoute.snapshot.routeConfig.path=='exprofile'){
    this.admin=false
   }
   
    
  }

  ngOnInit() {

    if(this.userId==undefined){
     
      if(this.admin==true){
        this.toastr.warning('Please select a user', '', {timeOut: 3000});
        this._router.navigate(['/users']);
       }else{
        this._router.navigate(['/home']);
       }
    }

    setTimeout(() => {
      this.loader_image=false
    }, 1000);
    
  }

  ngAfterViewInit(): void {
  
    $('.message a').click(function(e){
      e.preventDefault();
      
      $('form').animate({height: "toggle", opacity: "toggle"}, "slow");
   });

   $(document).ready(function(){ 
    $('input').blur(function(event) {
    var inputValue = this.value;
    if (inputValue) {
      this.classList.add('value-exists');
    } else {
      this.classList.remove('value-exists');
    }
    });
    });

    $('.button-psswd-2').on('click', function() {
        
      if ($('.input-psswd-2').attr('psswd-shown') == 'false') {
          
          $('.input-psswd-2').removeAttr('type');
          $('.input-psswd-2').attr('type', 'text');
          
          $('.input-psswd-2').removeAttr('psswd-shown');
          $('.input-psswd-2').attr('psswd-shown', 'true');
          
          $('#open_eye-2').hide();
          $('#close_eye-2').show();
          
      }else {
          
          $('.input-pssw-2').removeAttr('type');
          $('.input-psswd-2').attr('type', 'password');
          
          $('.input-psswd-2').removeAttr('psswd-shown');
          $('.input-psswd-2').attr('psswd-shown', 'false');
          
            $('#open_eye-2').show();
          $('#close_eye-2').hide();
          
      }
      
  });	
$('.button-psswd-3').on('click', function() {
      
      if ($('.input-psswd-3').attr('psswd-shown') == 'false') {
          
          $('.input-psswd-3').removeAttr('type');
          $('.input-psswd-3').attr('type', 'text');
          
          $('.input-psswd-3').removeAttr('psswd-shown');
          $('.input-psswd-3').attr('psswd-shown', 'true');
          
          $('#open_eye-3').hide();
          $('#close_eye-3').show();
          
      }else {
          
          $('.input-pssw-3').removeAttr('type');
          $('.input-psswd-3').attr('type', 'password');
          
          $('.input-psswd-3').removeAttr('psswd-shown');
          $('.input-psswd-3').attr('psswd-shown', 'false');
          
            $('#open_eye-3').show();
          $('#close_eye-3').hide();
          
      }
      
  });	

  }
  ngOnDestroy() {

    this.msgSubscribe.unsubscribe();
	  

  } 

 
  broadcast_menu(){
    
    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType});
   } 

   updateProfile(){
     if(this.pass!=this.confirm){
      this.toastr.error('Please enter same value for password and confirm password', '', {timeOut: 3000});
     }else{
      let data={
        token:this.token,
        id:this.userId,
        name: this.name,
        email:this.email,
        phone:this.phone,
        country:this.country,
        company:this.company,
        designation:this.designation,
        pass:this.pass,
        confirm:this.confirm,
        page:'users',
        external:this.external
       }
  
      this.userService.getUserList(data).subscribe( (response)=>{
    
          if(response.status=='success'){
            
            this.toastr.success('User updated successfully', '', {timeOut: 3000});
            if(this.admin==true){
              // this._router.navigate(['/users']);
              this._router.navigate(['/users'], { queryParams: { 'external':1} });
             }else{
              this._router.navigate(['/home']);
             }
  
          } else{
  
            this.toastr.error('User updation failed. Please try again later', '', {timeOut: 3000});
          }
    
      });
     }
     

   }

   back(){
     if(this.admin==true){
      // this._router.navigate(['/users']);
      this._router.navigate(['/users'], { queryParams: { 'external':1} });
     }else{
      this._router.navigate(['/home']);
     }
   }

   numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  fetchExprofileData(){

    if(this.userId!=undefined){
      this.loader_image = true
      let data={
        token:this.token,
        id:this.userId,
        page:'exprofile',
        external:this.external
      }
    
      this.userService.getUserList(data).subscribe( (response)=>{
          
          if(response.status=='success'){
            this.loader_image = false
           
            if(response.users[0]!=undefined){

              this.name = response.users[0].name
              this.email = response.users[0].email
              this.phone= response.users[0].phone
              this.country = response.users[0].country
              this.company = response.users[0].company
              this.designation= response.users[0].designation
  
              
            }
            

          } else{
            this.loader_image = false
            this.toastr.error('User details not found. Please try again later', '', {timeOut: 3000});
          }
    
      });

    }else{
      this.toastr.warning('Please select a user', '', {timeOut: 3000});
      this.loader_image = false
      if(this.admin==true){
        this._router.navigate(['/users']);
       }else{
        this._router.navigate(['/home']);
       }
    }

  }

}
